import { colors, Div, font, padding, position, space } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import React from 'react';
import PageHeading from '../../ui/PageHeading';
import SettingsPageTemplate from '../SettingsPageTemplate';
import PharmacyNetworks from '../../dashboard/components/PharmacyNetworks/PharmacyNetworks';

const sx = StyleSheet.create({
  description: {
    color: colors.gray57,
    lineHeight: font.lineHeight.looser,
  },
  boldDescription: {
    fontWeight: 'bold',
  },
  page: {
    ...position.size('100%'),
    maxWidth: 'initial',
    paddingBottom: 0,
  },
  pharmaciesNetworksPageContainer: padding.build(space.get(0), space.get(1.5), space.three),
});

const PharmacyNetworksPage = () => (
  <SettingsPageTemplate styles={sx.page}>
    <PageHeading title="Pharmacy Networks" />
    <Div styles={sx.pharmaciesNetworksPageContainer}>
      <PharmacyNetworks />
    </Div>
  </SettingsPageTemplate>
);

export default PharmacyNetworksPage;
